import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=12ff09ec&scoped=true"
import script from "@/lib/order/Form.js?vue&type=script&lang=js&external"
export * from "@/lib/order/Form.js?vue&type=script&lang=js&external"
import style0 from "@/lib/order/style/Form.css?vue&type=style&index=0&id=12ff09ec&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff09ec",
  null
  
)

export default component.exports